<template>
  <TableLayout v-permissions="['customer:project:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="案例编号" prop="serialNo">
          <el-input v-model="searchForm.serialNo" placeholder="请输入案例编号" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="案例名称" prop="projectName">
          <el-input v-model="searchForm.projectName" placeholder="请输入案例名称" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="进度" prop="status">
          <el-select v-model="searchForm.status" placeholder="请选择进度" clearable @change="search">
            <el-option label="待领取" value="WAIT"></el-option>
            <el-option label="制作中" value="MAKING"></el-option>
            <el-option label="已交付" value="COMPLETE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付状态" prop="status">
          <el-select v-model="searchForm.payStatus" placeholder="请选择支付状态" clearable @change="search">
            <el-option label="待收款" value="UNPAY"></el-option>
            <el-option label="已收款" value="PAID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市场" prop="customerRealname">
          <el-input v-model="searchForm.customerRealname" placeholder="请输入市场" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="客户" prop="keyword">
          <el-input v-model="searchForm.keyword" placeholder="请输入客户姓名" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="是否加急" prop="withPriority">
          <el-select v-model="searchForm.withPriority" placeholder="请选择是否加急" clearable @change="search">
          <el-option label="是" value="true"></el-option>
          <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否全程代理" prop="withProxy">
          <el-select v-model="searchForm.withProxy" placeholder="请选择是否全程代理" clearable @change="search">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否已提交" prop="withProxy">
          <el-select v-model="searchForm.withSubmit" placeholder="请选择是否已提交" clearable @change="search">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交付人" prop="deliveryUserInfoRealname">
          <el-input v-model="searchForm.deliveryUserInfoRealname" placeholder="请输入真实姓名" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="下单时间" prop="createTime">
          <el-date-picker
            v-model="searchForm.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            :picker-options="expireTimeOPtion"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @change="search"
          >
          </el-date-picker>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button :loading="isWorking.export" v-permissions="['customer:project:export:excel']" @click="exportExcel">导出</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <div class="but-wrap" v-permissions="['customer:project:collect', 'customer:project:delete']">
        <el-button type="primary" icon="el-icon-coin" v-permissions="['customer:project:collect']" @click="collectInBatch">收款</el-button>
        <el-button icon="el-icon-delete" v-permissions="['customer:project:delete']" @click="deleteByIdInBatch">删除</el-button>
      </div>
      <ul class="color-tip">
        <li>
          <span style="background: #eee;border-color: #e7e7e7;"></span>
          <span>已完成</span>
        </li>
        <li>
          <span style="background:#fff0e9;border-color: #f6e8e0;"></span>
          <span>加急</span>
        </li>
        <li>
          <span style="background:#e4f8ff;border-color: #d3e6ec;"></span>
          <span>全程代理</span>
        </li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        :row-class-name="getRowClassName"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" fixed></el-table-column>
        <el-table-column prop="serialNo" label="案例编号" min-width="160px" fixed></el-table-column>
        <el-table-column prop="projectName" label="案例名称" min-width="140px" fixed></el-table-column>
        <el-table-column prop="customer.realname" label="市场" min-width="120px"></el-table-column>
        <el-table-column prop="keyword" label="客户" min-width="140px"></el-table-column>
        <el-table-column prop="price" label="价格（元）" min-width="120px">
          <template slot-scope="{ row }">{{row.price == null ? '' : '¥' + row.price}}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" min-width="140px"></el-table-column>
        <el-table-column prop="withPriority" label="紧急程度" min-width="100px">
          <template slot-scope="{ row }">{{row.withPriority ? '加急' : '普通'}}</template>
        </el-table-column>
        <el-table-column prop="withProxy" label="代理模式" min-width="100px">
          <template slot-scope="{ row }">{{row.withProxy ? '全程代理' : '非全程代理'}}</template>
        </el-table-column>
        <el-table-column prop="withSubmit" label="是否提交" min-width="100px">
          <template slot-scope="{ row }">{{row.withSubmit ? '已提交' : '未提交'}}</template>
        </el-table-column>
        <el-table-column prop="projectRemark" label="项目备注" min-width="140px">
          <ColumnDetail slot-scope="{ row }" :content="row.projectRemark"/>
        </el-table-column>
        <el-table-column prop="deliveryUserInfo.realname" label="制作人/交付人" min-width="140px"></el-table-column>
        <el-table-column prop="deliveryTime" label="交付时间" min-width="140px"></el-table-column>
        <el-table-column prop="status" label="状态" min-width="140px">
          <template slot-scope="{ row }">{{row.payStatus | handlePayStatus}}</template>
        </el-table-column>
        <el-table-column prop="status" label="进度" min-width="140px">
          <template slot-scope="{ row }">{{row.status | handleStatus}}</template>
        </el-table-column>
        <el-table-column
          v-if="containPermissions([
          'customer:project:collect',
          'customer:project:receive',
          'customer:project:delivery',
          'customer:project:delete',
          'customer:project:update'
           ])"
          label="操作"
          min-width="370"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button
              v-if="row.withProxy && !row.withSubmit"
              v-permissions="['customer:project:submit']"
              type="primary"
              class="button-submit"
              icon="el-icon-s-promotion"
              @click="handleSubmit(row)"
            >提交</el-button>
            <el-button
              v-if="row.payStatus !== 'PAID'"
              v-permissions="['customer:project:collect']"
              type="text"
              @click="collect(row)"
              icon="el-icon-coin"
            >收款</el-button>
            <el-button
              v-if="row.status === 'WAIT'"
              v-permissions="['customer:project:receive']"
              type="text"
              @click="receive(row)"
              icon="el-icon-document-add"
            >领取案例</el-button>
            <template
              v-if="row.status === 'MAKING' && row.deliveryUserInfo != null && userInfo.id === row.deliveryUserInfo.id"
            >
              <el-button
                type="text"
                icon="el-icon-edit-outline"
                @click="designProject(row)"
              >立即制作</el-button>
              <el-button
                type="text"
                v-permissions="['customer:project:delivery']"
                @click="$refs.deliveryWindow.open('上传交付文件', row)"
                icon="el-icon-folder-checked"
              >交付</el-button>
            </template>
            <el-button
              v-if="row.status === 'COMPLETE' && row.deliveryUserInfo != null && userInfo.id === row.deliveryUserInfo.id"
              type="text"
              icon="el-icon-folder-checked"
              v-permissions="['customer:project:delivery']"
              @click="$refs.deliveryWindow.open('重新上传交付文件', row)"
            >重新交付</el-button>
            <el-button type="text" @click="$refs.operaProjectWindow.open('编辑客户案例', row)" icon="el-icon-edit" v-permissions="['customer:project:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['customer:project:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 交付 -->
    <DeliveryWindow ref="deliveryWindow" @success="deliverySuccess"/>
    <!-- 修改 -->
    <OperaProjectWindow ref="operaProjectWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import { mapState } from 'vuex'
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import ColumnDetail from '@/components/common/ColumnDetail'
import DeliveryWindow from '@/components/customer/DeliveryWindow.vue'
import OperaProjectWindow from '@/components/customer/OperaProjectWindow'
import { collect, receive, collectInBatch } from '@/api/customer/projectList'
import { submit } from '@/api/customer/project'
export default {
  name: 'project-list',
  extends: BaseTable,
  components: { OperaProjectWindow, DeliveryWindow, SearchFormCollapse, TableLayout, Pagination, ColumnDetail },
  data () {
    return {
      isWorkings: false,
      // 选择结束时间不能超过当天时间
      expireTimeOPtion: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      // 搜索
      searchForm: {
        serialNo: '',
        projectName: '',
        withPriority: '',
        withProxy: '',
        withSubmit: '',
        createTime: [],
        deliveryFileKey: '',
        status: '',
        customerCompany: '',
        customerRealname: '',
        keyword: '',
        deliveryUserInfoRealname: ''
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  filters: {
    handleStatus (value) {
      if (value === 'WAIT') {
        return '待领取'
      }
      if (value === 'MAKING') {
        return '制作中'
      }
      if (value === 'COMPLETE') {
        return '已交付'
      }
      return '未知'
    },
    handlePayStatus (value) {
      if (value === 'UNPAY') {
        return '待收款'
      }
      if (value === 'PAID') {
        return '已收款'
      }
      return '未知'
    }
  },
  methods: {
    // 交付成功
    deliverySuccess () {
      this.$tip.apiSuccess('交付成功')
      this.__refresh()
    },
    // 获取行class，根据状态区分出行
    getRowClassName ({ row }) {
      if (row.status === 'COMPLETE') {
        return 'complete-row'
      }
      if (row.withPriority) {
        return 'withPriority-row'
      }
      if (row.withProxy) {
        return 'withProxy-row'
      }
    },
    // 提交
    handleSubmit (row) {
      if (this.isWorkings) {
        return
      }
      this.isWorkings = true
      this.$dialog.confirm(`确认提交${row.projectName}案例吗？`, '提示', {
        confirmButtonText: '确认',
        type: 'warning'
      })
        .then(() => {
          submit({
            id: row.id,
            withSubmit: true
          })
            .then(() => {
              this.$tip.success('提交成功')
              this.__refresh()
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.isWorkings = false
            })
        })
        .catch(() => {
          this.isWorkings = false
        })
    },
    // 收款
    collect (row) {
      if (this.isWorkings) {
        return
      }
      this.isWorkings = true
      this.$dialog.confirm(`确认收款${row.projectName}案例吗？`, '提示', {
        confirmButtonText: '确认',
        type: 'warning'
      })
        .then(() => {
          collect(row.id)
            .then(() => {
              this.$tip.apiSuccess('恭喜彭总收款成功')
              this.__refresh()
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.isWorkings = false
            })
        })
        .catch(() => {
          this.isWorkings = false
        })
    },
    // 领取案例
    receive (row) {
      if (this.isWorkings) {
        return
      }
      this.isWorkings = true
      this.$dialog.confirm(`确认领取${row.projectName}案例吗？`, '提示', {
        confirmButtonText: '确认',
        type: 'warning'
      })
        .then(() => {
          receive(row.id)
            .then(() => {
              this.$tip.apiSuccess('已领取案例')
              this.__refresh()
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.isWorkings = false
            })
        })
        .catch(() => {
          this.isWorkings = false
        })
    },
    // 立即制作
    designProject (row) {
      // 跳转到生成代码页面
      this.$router.push({
        path: '/ai/index',
        query: {
          logo_file_key: row.logoFileKey,
          project_name: row.projectName.trim()
        }
      })
    },
    // 批量收款
    collectInBatch () {
      // 未勾选
      if (this.tableData.selectedRows.length === 0) {
        this.$tip.warning('请至少选择一个案例')
        return
      }
      let message = ''
      // 已经付完款的项目
      let alreadyPayment = this.tableData.selectedRows.filter(item => item.payStatus === 'PAID')
      const alreadyPaymentCount = alreadyPayment.length
      // 组装已支付的项目信息
      if (alreadyPayment.length > 0 && alreadyPayment.length <= 2) {
        message = alreadyPayment.map(item => item.projectName).join('、')
      } else if (alreadyPayment.length > 2) {
        alreadyPayment = alreadyPayment.splice(0, 2)
        message = alreadyPayment.map(item => item.projectName).join('、') + `等${alreadyPaymentCount}个`
      }
      // 警告重复收款
      if (alreadyPayment.length !== 0) {
        this.$dialog.confirm(message + '案例已收款，请勿重复收款', '请勿重复收款', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'error'
        })
        return
      }
      // 组装要收款的项目信息
      let selectedRows = this.tableData.selectedRows
      const rowCount = this.tableData.selectedRows.length
      let projects = ''
      if (selectedRows.length <= 2) {
        projects = selectedRows.map(item => item.projectName).join('、')
      } else {
        selectedRows = selectedRows.filter((item, index) => index < 2)
        projects = selectedRows.map(item => item.projectName).join('、') + `等${rowCount}个`
      }
      // 警告是否已经收款
      this.$dialog.confirm(`确认收款${projects}案例吗？`, '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      })
        .then(() => {
          collectInBatch(this.tableData.selectedRows.map(item => item.id).join(','))
            .then(() => {
              this.__refresh()
              this.$tip.apiSuccess('恭喜彭总收款成功')
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
        })
        .catch(() => {})
    },
    /**
     * 页码变更处理（分页时触发）
     *
     * @param pageIndex 新页码
     */
    handlePageChange (pageIndex) {
      this.__checkApi()
      this.tableData.pagination.pageIndex = pageIndex || this.tableData.pagination.pageIndex
      this.isWorking.search = true
      this.api.fetchList({
        page: this.tableData.pagination.pageIndex,
        capacity: this.tableData.pagination.pageSize,
        model: {
          ...this.searchForm,
          startCreateTime: this.searchForm.createTime == null ? null : this.searchForm.createTime[0],
          endCreateTime: this.searchForm.createTime == null ? null : this.searchForm.createTime[1]
        },
        sorts: this.tableData.sorts
      })
        .then(data => {
          this.tableData.list = data.records
          this.tableData.pagination.total = data.total
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.isWorking.search = false
        })
    },
    /**
     * 导出Excel（点击导出按钮时触发）
     */
    exportExcel () {
      this.$dialog.exportConfirm('确认导出吗？')
        .then(() => {
          this.isWorking.export = true
          this.api.exportExcel({
            page: 1,
            capacity: 1000000,
            model: {
              ...this.searchForm,
              startCreateTime: this.searchForm.createTime == null ? null : this.searchForm.createTime[0],
              endCreateTime: this.searchForm.createTime == null ? null : this.searchForm.createTime[1]
            },
            sorts: this.tableData.sorts
          })
            .then(response => {
              this.download(response)
            })
            .catch(e => {
              this.$tip.apiFailed(e)
            })
            .finally(() => {
              this.isWorking.export = false
            })
        })
        .catch(() => {})
    }
  },
  created () {
    this.config({
      module: '客户案例',
      api: '/customer/project',
      'field.id': 'id',
      'field.main': 'projectName'
    })
    this.search()
  }
}
</script>
<style scoped lang="scss">
.logo {
  width: 60px;
  height: 60px;
  object-fit: contain;
}
// 完成
/deep/ .complete-row {
  $background: #eee;
  background: $background !important;
  td {
    background: $background !important;
  }
  &.hover-row td {
    background: $background !important;
  }
}
// 加急
/deep/ .withPriority-row {
  background-color: #fff0e9 !important;
  td {
    background-color: #fff0e9 !important;
  }
  &.hover-row td {
    // fff6f2
    background: #fff0e9 !important;
  }
}
// 全程代理
/deep/ .withProxy-row {
  background-color: #eaf8ff !important;
  td {
    background-color: #eaf8ff !important;
  }
  &.hover-row td {
    background: #eaf8ff !important;
  }
}
.color-tip {
  list-style: none;
  margin: 0;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  border-bottom: 1px solid #e9e9e9;
  li {
    display: flex;
    align-items: center;
    font-size: 13px;
    margin-right: 15px;
    span {
      color: #666;
      &:first-of-type {
        height: 20px;
        width: 50px;
        margin-right: 10px;
        border: 1px solid transparent;;
      }
    }
  }
}
// 提交按钮
.button-submit {
  padding: 5px 7px!important;
  background-color: #ce5c5c!important;
  border: 0;
  &:hover {
    background-color: #c95050!important;
  }
}
</style>
